import { defineStore, getActivePinia } from 'pinia'

import { state } from './state'

export const pageScrollStore = (gaApp) => {
  const init = defineStore('appPageScroll', {
    state,
  })

  return init(getActivePinia())
}
